import type {
  HttpNodeOptions,
  JobsCreateNodeOptions,
  NodeDef,
  PromptNodeOptions,
} from '../types';

export function promptNode(name: string, options: PromptNodeOptions): NodeDef {
  return { name, entryBehavior: 'loom.prompt', promptOptions: options };
}

export function httpNode(name: string, options: HttpNodeOptions): NodeDef {
  return { name, entryBehavior: 'http.request', httpOptions: options };
}

export function jobsCreateNode(name: string, options: JobsCreateNodeOptions): NodeDef {
  return { name, entryBehavior: 'jobs.create', jobsCreateOptions: options };
}
